import { useState } from "react";
import { Check, CaretDown } from "@phosphor-icons/react";
import { cn } from "@/lib/utils";
import { WORLD_COUNTRIES } from "@/lib/countries";
import { Button } from "@/components/ui/button";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import {
  Command, CommandInput, CommandList, CommandEmpty, CommandGroup, CommandItem,
} from "@/components/ui/command";

export default function CountrySelect({ value, onChange, placeholder = "Country", testId = "country-select" }) {
  const [open, setOpen] = useState(false);
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button
          type="button"
          variant="outline"
          role="combobox"
          aria-expanded={open}
          data-testid={testId}
          className={cn(
            "w-full justify-between rounded-md font-normal",
            !value && "text-muted-foreground"
          )}
        >
          <span className="truncate">{value || placeholder}</span>
          <CaretDown size={16} className="ml-2 shrink-0 opacity-50" />
        </Button>
      </PopoverTrigger>
      <PopoverContent className="z-[80] w-[--radix-popover-trigger-width] p-0" align="start">
        <Command>
          <CommandInput placeholder="Type a country…" data-testid={`${testId}-input`} />
          <CommandList>
            <CommandEmpty>No country found.</CommandEmpty>
            <CommandGroup>
              {WORLD_COUNTRIES.map((c) => (
                <CommandItem
                  key={c}
                  value={c}
                  data-testid={`${testId}-option-${c}`}
                  onSelect={() => {
                    onChange(c === value ? "" : c);
                    setOpen(false);
                  }}
                >
                  <Check size={16} className={cn("mr-2", value === c ? "opacity-100" : "opacity-0")} />
                  {c}
                </CommandItem>
              ))}
            </CommandGroup>
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
}
